import {
  VuexModule, Module, Action,
} from 'vuex-module-decorators';
import Vue from 'vue';
import {
  BASE_URL,
  M_POST,
  FECTH_POINT,
  USE_POINT,
  GET_USER_PROFILE,
} from '@/utils/api';

@Module({ name: 'ExchangePoint' })
export default class ExchangePoint extends VuexModule {
  @Action
  getPoint() {
    return Vue.axios({
      url: BASE_URL + FECTH_POINT,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code) {
          throw data.status;
        } else {
          return data;
        }
      })
      .catch((err: string) => err);
  }

  @Action
  usePoint(param: any) {
    return Vue.axios({
      url: BASE_URL + USE_POINT,
      method: M_POST,
      data: param,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code) {
          throw data;
        } else {
          return data;
        }
      })
      .catch((err: string) => err);
  }

  @Action
  getDetail() {
    return Vue.axios({
      url: BASE_URL + GET_USER_PROFILE,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code) {
          throw data.status;
        } else {
          return data;
        }
      })
      .catch((err: string) => err);
  }
}
